<template>
  <div
    class="loader border-t-primary-500"
    data-testid="client-spinner"
  >
    Loading...
  </div>
</template>

<script>
export default {
  name: "ClientSpinner",
}
</script>

<style scoped></style>
